import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input, AfterViewInit } from "@angular/core";
import { CommonModule } from "@angular/common";

declare const pdfjsLib: any;

@Component({
    selector: "app-pdf-viewer",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./pdf-viewer.component.html",
    styleUrl: "./pdf-viewer.component.scss",
})
export class PdfViewerComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() pdfUrl!: string;
    @ViewChild("canvasContainer") canvasContainer!: ElementRef<HTMLDivElement>;

    currentPage = 1;
    totalPages = 0;
    scale = 1.5; // Tăng tỷ lệ scale mặc định lên để tăng độ sắc nét khi canvas co giãn CSS 100%
    isLoading = true;
    error = "";

    private pdfDoc: any = null;
    private renderTask: any = null;

    ngOnInit(): void {
        this.loadPdfJs();
    }

    ngAfterViewInit(): void {}

    ngOnDestroy(): void {
        // Hủy bỏ tiến trình render ngầm để tránh rò rỉ bộ nhớ (Memory Leak)
        this.renderTask?.cancel();
        this.pdfDoc?.destroy();
    }

    private loadPdfJs(): void {
        if (typeof pdfjsLib !== "undefined") {
            this.initPdf();
            return;
        }

        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.min.mjs";
        script.type = "module";
        script.onload = () => this.initPdf();
        script.onerror = () => {
            this.error = "Không thể tải thư viện hiển thị tài liệu.";
            this.isLoading = false;
        };
        document.head.appendChild(script);
    }

    private async initPdf(): Promise<void> {
        try {
            pdfjsLib.GlobalWorkerOptions.workerSrc =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs";

            this.pdfDoc = await pdfjsLib.getDocument(this.pdfUrl).promise;
            this.totalPages = this.pdfDoc.numPages;
            this.isLoading = false;

            // Chạy Render bất đồng bộ toàn bộ các trang phẳng
            setTimeout(() => {
                this.renderAllPages();
            }, 0);
        } catch (e) {
            this.error = "Không thể đọc nội dung file PDF từ hệ thống.";
            this.isLoading = false;
        }
    }

    private async renderAllPages(): Promise<void> {
        if (!this.canvasContainer) return;
        const container = this.canvasContainer.nativeElement;
        container.innerHTML = "";

        for (let i = 1; i <= this.totalPages; i++) {
            const page = await this.pdfDoc.getPage(i);

            // Thiết lập viewport với scale sắc nét
            const viewport = page.getViewport({ scale: this.scale });

            const wrapper = document.createElement("div");
            wrapper.className = "pdf-page-wrapper";
            wrapper.setAttribute("data-page", String(i));

            const canvas = document.createElement("canvas");

            // Gán kích thước resolution thực tế cho canvas dựa theo cấu trúc file gốc
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            wrapper.appendChild(canvas);
            container.appendChild(wrapper);

            // Thực hiện vẽ dữ liệu PDF lên bề mặt Canvas đồ họa
            this.renderTask = page.render({
                canvasContext: canvas.getContext("2d")!,
                viewport,
            });

            await this.renderTask.promise;
        }
    }
}